export function getStatusItem(item) {
    const hoje = new Date();
    const dataFim = item?.dataFim ? new Date(item.dataFim) : null;
    const dataHomologado = item?.dataHomologado ? new Date(item.dataHomologado) : null;

    if (dataHomologado) {
        if (!dataFim) return 'Homologado';
        return dataHomologado <= dataFim ? 'Homologado no prazo' : 'Homologado com atraso';
    }

    if (!dataFim) return 'Sem prazo';

    if (hoje > dataFim) return 'Atrasado';

    return 'Em prazo';
}

export function getResumoHomologacao(itens = []) {
    const resumo = {
        total: 0,
        homologados: 0,
        homologadosNoPrazo: 0,
        homologadosComAtraso: 0,
        emPrazo: 0,
        atrasados: 0,
        semPrazo: 0,
        progresso: 0,
    };

    itens.forEach((item) => {
        const status = getStatusItem(item);

        resumo.total += 1;

        if (status === 'Homologado') resumo.homologados += 1;
        if (status === 'Homologado no prazo') {
            resumo.homologados += 1;
            resumo.homologadosNoPrazo += 1;
        }
        if (status === 'Homologado com atraso') {
            resumo.homologados += 1;
            resumo.homologadosComAtraso += 1;
        }
        if (status === 'Em prazo') resumo.emPrazo += 1;
        if (status === 'Atrasado') resumo.atrasados += 1;
        if (status === 'Sem prazo') resumo.semPrazo += 1;
    });

    resumo.progresso = resumo.total === 0 ? 0 : Math.round((resumo.homologados / resumo.total) * 100);

    return resumo;
}
